import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Color } from '@/types';
import { useCreateColorMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateColorProps extends DialogProps {
  onClose(): void;
}

const CreateColor: React.FC<CreateColorProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createColor, createColorResponse] = useCreateColorMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Color>({
    initialValues: {
      name: '',
      hex: '#000000',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
      hex: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(color, { resetForm }) {
      try {
        await createColor(color).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить цвет</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createColorResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="hex"
                label="Цвет"
                type="color"
                placeholder="Введите значение"
                value={values.hex}
                onChange={handleChange}
                disabled={createColorResponse.isLoading}
                error={touched.hex && Boolean(errors.hex)}
                helperText={touched.hex ? errors.hex : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createColorResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createColorResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateColor;
